import React, { Component } from "react";
import { PageHeader, Button, Alert, Spin } from "antd";
import OpsReportService from "../../services/opsreportservice";

/**
 * Audit -> Ads Report. Renders the daily Google Ads performance page.
 *
 * The page itself is built on web40 each morning and copied to a folder OUTSIDE the web root, so
 * the only way to read it is this screen: the WebAPI checks the caller is a portal user holding
 * the "Ops Review" right before it returns a byte. It used to sit at karelabel.com/ops/, where it
 * was readable by anyone with the URL.
 *
 * The HTML arrives as a string and goes into a fully sandboxed iframe via srcDoc -- no scripts, no
 * same-origin access, so a report can never reach into the portal session. The report carries its
 * own styles, which is why it is framed rather than injected into the page.
 */
export default class AdsReport extends Component {
  constructor(props) {
    super(props);
    this.service = new OpsReportService();
    this.state = { html: "", loading: true, error: "" };
  }

  componentDidMount() {
    this.load();
  }

  load = () => {
    this.setState({ loading: true, error: "" });
    this.service
      .getReport("ads")
      .then((out) => {
        if (out && out.html) {
          this.setState({ html: out.html, loading: false });
        } else {
          this.setState({
            loading: false,
            error:
              (out && out.message) ||
              "Could not load the report. Try again in a moment.",
          });
        }
      })
      .catch(() => {
        this.setState({
          loading: false,
          error: "Could not load the report. Try again in a moment.",
        });
      });
  };

  render() {
    const { html, loading, error } = this.state;
    return (
      <div className="ads-report-wrap">
        <PageHeader
          title="Ads Report"
          subTitle="Google Ads performance since day one - rebuilt every morning"
          extra={[
            <Button key="refresh" onClick={this.load} disabled={loading}>
              Refresh
            </Button>,
          ]}
        />
        {error ? (
          <Alert type="warning" showIcon message={error} style={{ margin: 16 }} />
        ) : null}
        {loading ? (
          <div style={{ textAlign: "center", padding: 60 }}>
            <Spin tip="Loading the report..." />
          </div>
        ) : null}
        {!loading && !error && html ? (
          <iframe
            title="Ads Report"
            srcDoc={html}
            sandbox=""
            style={{
              width: "100%",
              height: "calc(100vh - 170px)",
              border: "1px solid #e8e8e8",
              borderRadius: 4,
              background: "#fff",
            }}
          />
        ) : null}
      </div>
    );
  }
}
